import React, { useEffect } from 'react';
import RichTextField from '@components/common/form/RichTextField';
import UploadImage from '@components/common/form/UploadImage';
import { commonStatus, statusOptions } from '@constants/masterData';
import useTranslate from '@hooks/useTranslate';
import { NumericField, SelectField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { calcCoefficient } from '@utils';
import { Col, Form, Row } from 'antd';
const IngredientsForm = ({ detail, form, onSubmit, setIsChangedFormValues, isEditing }) => {
    const translate = useTranslate();
    const statusValues = translate.formatKeys(statusOptions, ['label']);

    useEffect(() => {
        if (detail) {
            form.setFieldsValue({
                foodConditionName: detail?.foodConditionName,
                foodConditionPrice: calcCoefficient(detail?.foodConditionPrice, 100),
                // foodConditionPrice: detail?.foodConditionPrice,
                plu: detail?.plu,
                productInfo: detail?.productInfo,
                status: detail?.status,
            });
        }
    }, [detail]);

    const handleSubmit = (values) => {
        const preparedData = {
            foodConditionName: values.foodConditionName,
            foodConditionPrice: calcCoefficient(values.foodConditionPrice, 0.01),
            // foodConditionPrice: values.foodConditionPrice,
            productInfo: values.productInfo,
            plu: values.plu,
            status: values.status,
        };

        if (detail) {
            preparedData.id = detail.id;
        }
        onSubmit(preparedData);
    };
    return (
        <Form form={form} layout="vertical" onFinish={handleSubmit} onValuesChange={() => setIsChangedFormValues(true)}>
            <Row gutter={24}>
                <Col span={12}>
                    <TextField name="foodConditionName" label={translate.formatMessage(commonMessage.name)} required />
                </Col>
                <Col span={12}>
                    <NumericField
                        formatter={(v) => v}
                        parser={(v) => v}
                        min={0}
                        name="foodConditionPrice"
                        label={translate.formatMessage(commonMessage.price)}
                        required
                    />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={12}>
                    <TextField name="plu" label={translate.formatMessage(commonMessage.plu)} />
                </Col>
                {isEditing && (
                    <Col span={12}>
                        <SelectField
                            label={translate.formatMessage(commonMessage.status)}
                            name="status"
                            required
                            options={statusValues}
                        />
                    </Col>
                )}
                <Col span={24}>
                    <RichTextField
                        name="productInfo"
                        label={translate.formatMessage(commonMessage.productInfo)}
                        type="textarea"
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default IngredientsForm;
